

declare interface Loja {
latitude: string;
longitude: string;
    cod: string,
    param: string
  }


import {
  IonPage,
  IonContent ,
  IonItem,
  IonMenu,
  IonAlert,
  IonApp,
  IonList,
  IonLabel,
  IonListHeader,
  IonRow,
  IonCol,
  IonMenuToggle,
  IonToolbar,
  IonButton,
  IonFooter,
  IonSpinner,
  IonIcon,
  alertController,
  IonTitle,
  IonInput,
  IonBackButton,
  IonAccordion,
  IonAccordionGroup,
  IonNote,
  IonRadio,
  IonRadioGroup,
  IonDatetime

} from '@ionic/vue';

import fintailapi from '../api'

import { cart, chevronBackCircle,chevronBack  } from 'ionicons/icons';

import {useStore} from "vuex";
import { defineComponent } from 'vue';

import maska from 'maska';

import SafeArea  from '../components/SafeArea.vue'

import SelectDia  from '../components/SelectDia.vue'

import moment from 'moment'

export default defineComponent({
  components: {
      IonContent,
      IonPage,
      IonItem,
      IonAlert,
      IonList,
      IonMenu,
      IonInput,
      IonButton,
      IonTitle,
      IonRow,
      IonCol,
      IonToolbar,
      IonApp,
      IonIcon,
      IonLabel,
      IonSpinner,
      alertController,
      IonListHeader,
      IonMenuToggle,
      IonFooter,
      IonBackButton,
      IonAccordion,
      IonAccordionGroup,
      IonNote,
      IonRadio,
      IonRadioGroup,
      SafeArea,
      maska,
      IonDatetime,
      SelectDia
  },
  data() {
    return {
      cadastro: {celular:"", nascimento:"", dia_nascimentos:1, dia_nascimento:"0001-01-01T00:0:00-00:00", mesano_nascimento:"1990-01-01T00:0:00-00:00"},
      store : useStore(),
      chevronBackCircle,
      chevronBack,
      isEnviando: false,
      isOpenRef : false,
      loading : true,
      yearValues : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30]

    }
  },
  computed: {
    lojas() {

    }
  },
  methods: {
    setOpen(state: boolean){
       this.isOpenRef = state
    },
    voltar() {
      this.$router.back()
    },
    gotoExcluir() {


      alertController.create({
          header: 'Exclusão de Dados',
          message: "Deseja realmente excluir seus dados na rede Jaú Serve",
          buttons: [
            {

              text: 'Cancelar',
              role: 'cancel',
              handler: () => {

              },
            },
            {
              text: 'Sim',
              role: 'confirm',
              handler: (imSenha) => {

                this.store.state.user.suporte={ tipo:1, mensagem: "Desejo excluir minha conta e dados no app Jaú Serve" }
                this.$router.push("/suporte")

              },
            },
          ]
        }).then((response:any) => {

         response.present();

        });




    },
    changeDt() {


      const dd = moment(this.cadastro.dia_nascimento).format("YY");

      const mmyyy = moment(this.cadastro.mesano_nascimento).format("yyyy-MM");

      this.cadastro.nascimento = mmyyy+"-"+dd
      console.log( this.cadastro.nascimento)

    },
    presentAlert : async (titulo:any, subHeader:any, message:any) => {
        const alert = await alertController.create({
          header: titulo,
          subHeader: subHeader,
          message: message,
          buttons: ['OK'],
        });

        await alert.present();
  },
    save() {

      this.isEnviando = true;

      fintailapi
      .post('/user/me', { "user": this.cadastro})
      .then((response:any) => {
        const data = response.data
        this.isEnviando = false;
        if (data.success) {
          this.presentAlert("Cadastro", "",data.return);
          //this.cadastro = data.user
        }

      }).catch((error) => {

        this.isEnviando = false
        this.presentAlert("Atenção", ""," Ocorreu um erro ao alterar seus dados, por favor tente novamente, se caso o erro persistir utilize nosso chat!");

      })

    },
    showPerfil() {
      fintailapi
      .get('/user/me')
      .then((response:any) => {

        this.loading = false;

        const data = response.data

        if (data.success) {
          this.cadastro = data.user
          this.cadastro.dia_nascimentos = parseInt(this.cadastro.dia_nascimento);
        }

      })
    }
  },
  created() {
    this.showPerfil()
  },
});


/*
  horarios = {"1002":["Fechado","Fechado","07:30 as 19:30","Fechado","Fechado","07:30 as 19:30"],"1003":["08:00 as 13:30","08:00 \u00e0s 13:00","07:30 as 21:00","08:00 as 13:30","08:00 \u00e0s 13:00","07:30 as 21:00"],"1004":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00"],"1005":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00"],"1006":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00"],"1007":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 21:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 21:00"],"1008":["8:00 as 13:00","08:00 \u00e0s 13:00","8:00 as 19:30","8:00 as 13:00","08:00 \u00e0s 13:00","8:00 as 19:30"],"1009":["8:00 as 20:00","08:00 \u00e0s 20:00","8:00 as 22:00","8:00 as 20:00","08:00 \u00e0s 20:00","8:00 as 22:00"],"1010":["08:00 a 13:00","08:00 \u00e0s 13:00","08:00 as 20:00","08:00 a 13:00","08:00 \u00e0s 13:00","08:00 as 20:00"],"1011":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00"],"1012":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00"],"1013":["07:30 as 13:00","07:30 \u00e0s 13:00","07:30 as 20:30","07:30 as 13:00","07:30 \u00e0s 13:00","07:30 as 20:30"],"1014":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 19:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 19:00"],"1015":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 21:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 21:00"],"1016":["08:00 as 13:00","08:00 as 20:00","08:00 as 13:00","08:00 as 20:00"],"1017":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 21:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 21:00"],"1018":["07:30 as 13:00","08:00 \u00e0s 13:00","07:30 as 20:00","07:30 as 13:00","08:00 \u00e0s 13:00","07:30 as 20:00"],"1019":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 21:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 21:00"],"1020":["8:00 as 13:00","8:00 as 13:00","8:00 as 21:00","8:00 as 13:00","8:00 as 13:00","8:00 as 21:00"],"1021":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00"],"1022":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 19:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 19:00"],"1023":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00"],"1024":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:30","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:30"],"1025":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00"],"1026":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:30","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:30"],"1027":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 19:30","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 19:30"],"1028":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 21:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 21:00"],"1029":["08:00 as 20:00","08:00 \u00e0s 20:00","08:00 as 22:00","08:00 as 20:00","08:00 \u00e0s 20:00","08:00 as 22:00"],"1030":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00"],"1031":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 21:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 21:00"],"1032":["08:00 as 20:00","08:00 \u00e0s 20:00","08:00 as 22:00","08:00 as 20:00","08:00 \u00e0s 20:00","08:00 as 22:00"],"1033":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00"],"1034":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 21:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 21:00"],"1035":["08:00 as 20:00","08:00 \u00e0s 20:00","08:00 as 21:00","08:00 as 20:00","08:00 \u00e0s 20:00","08:00 as 21:00"],"1036":["8h \u00e0s 13h.","Fechado","08:00 \u00e0s 19:30","8h \u00e0s 13h.","Fechado","08:00 \u00e0s 19:30"],"1038":["8h \u00e0s 19h.","08:00 \u00e0s 19:00","08:00 \u00e0s 22:00","8h \u00e0s 19h.","08:00 \u00e0s 19:00","08:00 \u00e0s 22:00"],"1040":["07:30 as 19:00","07:30 \u00e0s 19:00","07:30 as 21:00","07:30 as 19:00","07:30 \u00e0s 19:00","07:30 as 21:00"],"1041":["08:00 as 19:00","08:00 \u00e0s 19:00","08:00 as 21:00","08:00 as 19:00","08:00 \u00e0s 19:00","08:00 as 21:00"],"1042":[" 08:00 as 19:30 ","08:00 \u00e0s 21:00","08:00 as 21:00"," 08:00 as 19:30 ","08:00 \u00e0s 21:00","08:00 as 21:00"],"1043":["08:00 as 19:00","08:00 as 21:00","08:00 as 19:00","08:00 as 21:00"]};


*/

